<template>
  <div class="hidden md:block md:col-span-3 lg:col-span-3 py-8 lg:py-12 sticky top-0 self-start">
    <ClientOnly>
      <div :class="{ 'tocs--scroll hide-scrollbar': tocsScroll }">
        <ul v-if="tocs" ref="tocsRef">
          <li class="text-gray-900 mt-4 text-sm font-bold">
            Contents
          </li>
          <li 
          v-for="(toc, index) in tocs" 
          :key="'toc'+index"
          class="text-gray-500 mt-4 font-normal text-sm cursor-pointer"
          @click="goToSection(toc.id)"
          >
            {{ toc.innerText }}
          </li>
        </ul>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup>
const tocs = ref([])
const tocsRef = ref(null)
const tocsScroll = ref(null)

onMounted(async () => {
  let toc = []
  const elementsH = document.querySelectorAll('h2')
  if (elementsH.length) {
    elementsH.forEach((element, index) => {
      const id = `toc_${index}`
      const type = element.tagName.toLowerCase()
      element.setAttribute('id', id)
      if (element.innerText !== 'You might also like') {
        toc.push({
          id,
          type,
          innerText: element.innerText
        })
      }
    })
    tocs.value = toc
  }

  await nextTick()
  const ulHeight = tocsRef.value.clientHeight;
  if (window.innerWidth > 1000 && ulHeight > window.innerHeight - 100) {
    tocsScroll.value = true
  }
})

const goToSection = id => {
  const el = document.getElementById(id)
  const yPos = getOffset(el).top - 100
  window.scrollTo({ top: yPos, behavior: 'smooth' })
}

const getOffset = el => {
  const rect = el.getBoundingClientRect()
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  }
}

</script>

<style lang="scss">
// .tocs--scroll {
//   height: calc(100vh - 100px);
//   position: absolute;
//   top: 99px;
//   overflow-y: scroll;
//   ul {
//     padding-bottom: 40px;
//   }
// }
</style>